import React from "react";
import { Form, Input, Checkbox, Select, Spin } from "antd";
import { OneFrontDatePicker } from "../../Components/Forms/BookyDatePicker";
import { UiControlType } from "../../Types/UiControlType";
import { useCustomListLookupDataForForm } from "../../Hooks/useCustomListLookupDataForForm";
import { WebApiCustomListsDtoCustomListItemDto } from "../../Repository/eventbookyapi";

const { Option } = Select;


const CustomListItemForm = ({
    form,
    customFields,
    lookupOptions,
    mode
}: {
    form: any,
    customFields: any[],
    lookupOptions?: WebApiCustomListsDtoCustomListItemDto[],
    mode: "add" | "edit"
}) => {

    return (
        <Form form={form} layout="vertical">
            {customFields.map(field => {
                if (field.uiControl === UiControlType.Date) {
                    return (
                        <OneFrontDatePicker
                            key={field.id}
                            name={field.id}
                            label={field.nameAdmin}
                            required={field.mandatoryAdmin}
                        />
                    );
                }
                let input = <Input />;
                if (field.uiControl === UiControlType.YesNo) input = <Checkbox checked={form.getFieldValue(field.id)} />;
                if (field.uiControl === UiControlType.Lookup) {
                    const options = lookupOptions;
                    input = !options ? <Spin size="small" /> : (
                        <Select
                            showSearch
                            value={form.getFieldValue(field.id)}
                            filterOption={(input, option) => {
                                const label = option?.children;
                                return label ? label.toString().toLowerCase().includes(input.toLowerCase()) : false;
                            }}
                        >
                            {options.map((opt: WebApiCustomListsDtoCustomListItemDto) => (
                                <Option key={String(opt.id)} value={opt.id}>{opt.fieldValues![0]?.fieldValue || opt.id?.toString()}</Option>
                            ))}
                        </Select>
                    );
                }
                if (field.uiControl === UiControlType.Dropdown) input = (
                    <Select>
                        {field.alternatives!.split(";").map((opt: any) => (
                            <Option key={opt} value={opt}>{opt}</Option>
                        ))}
                    </Select>
                );
                return (
                    <Form.Item
                        key={field.id}
                        name={field.id}
                        label={field.nameAdmin}
                        {...((field.uiControl === UiControlType.YesNo) ? { valuePropName: "checked" } : {})}
                        rules={field.mandatoryAdmin ? [{ required: true, message: `Ange ${field.nameAdmin}` }] : []}
                    >
                        {input}
                    </Form.Item>
                );
            })}
        </Form>
    );
};

export default CustomListItemForm;
